/**
 * Not Found Component.
 *
 * @returns {JSX.Element}
 */
export default function NotFound() {
	return <>Component Not Found.</>;
}
